import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kindergarten-events',
  templateUrl: './kindergarten-events.component.html',
  styleUrls: ['./kindergarten-events.component.scss']
})
export class KindergartenEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
